import { useEffect, useLayoutEffect, useRef, useState } from 'react'
import { ApiCmnHeadersPostCall, ApiGetCallAuthKey } from '../../JS/Connector';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import VideoUpload from '../SupportTicket/VideoUpload';
import ReCAPTCHA from 'react-google-recaptcha';
import { CheckValidation, ValidateFile } from '../../Components/Validations';
import { CustomParseSafeHtml, HideLoder, ShowLoder, compressImage, getAllBuildings, isValidEmail } from '../../JS/Common';
import AlertsComp from '../../Components/AlertsComp';
import { GoogleLoginForSupportTicket } from '../Signin/GoogleLoginForSupportTicket';
import { MicrosoftLoginForSupportTicket } from '../Signin/MicrosoftLoginForSupportTicket';
import CustomSVG from '../../Components/CustomSVG';
import { log } from '../../JS/Logger';
import { useSelector } from 'react-redux';
import useConfig from '../../Hooks/useConfig';
import "react-quill/dist/quill.core.css";

const Dotsloder = () => {
    return (
        <section className="dots-container pb-5">
            <div className="dot"></div>
            <div className="dot"></div>
            <div className="dot"></div>
        </section>
    )
}

const HoverPopover = ({ item, icon }) => {
    const [show, setShow] = useState(false);
    const timer = useRef();

    const open = () => {
        clearTimeout(timer.current);
        setShow(true);
    };

    const close = () => {
        timer.current = setTimeout(() => {
            setShow(false);
        }, 200);
    };

    return (
        <OverlayTrigger
            show={show}
            placement="auto"
            trigger={[]}
            overlay={
                <Popover
                    onMouseEnter={open}
                    onMouseLeave={close}
                    onClick={(e) => e.stopPropagation()}
                    id={`helpdesk-popover-${item.name}`}
                >
                    <Popover.Header as="h3">
                        {item.name}
                    </Popover.Header>
                    <Popover.Body className='ql-editor'>
                        {item.description && item.description.replace(/<[^>]*>/g, '').trim()
                            ? CustomParseSafeHtml(item.description)
                            : "No Description Found"}
                    </Popover.Body>
                </Popover>
            }
        >
            <img
                src={icon}
                className="img-fluid cursor-pointer ps-2"
                style={{
                    height: icon.includes("white") ? "18px" : "16px"
                }}
                onMouseEnter={open}
                onMouseLeave={close}
                onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();   // <-- Add this
                }}
            />
        </OverlayTrigger>
    );
};

const Category = ({ data, onClick, labelname, set, setString, setter, selectedId, resetCategories, setShowDetailsDiv }) => {
    return (
        <div className='row py-3'>
            <div className="col-12">
                <div className='col-md-5 questionchatbox'>
                    {labelname}
                </div>
            </div>
            <div className='col-12 my-2'>
                {data.length > 0 ?
                    <div className={`ps-0 d-flex flex-wrap ${set[setString]?.activeID ? 'justify-content-end' : ''}`}>{
                        data.map((item, index) => (
                            set[setString]?.activeID ?
                                <div className='text-end' key={index}>
                                    <div className="float-end" key={index}>
                                        <button className={`helpDesk-button px-3 py-2 cursor-pointer ${item[selectedId] == set[setString]?.activeID ? "active" : "d-none"} m-2 `} key={index}
                                            title={item.name}>
                                            <label>
                                                {item.icon &&
                                                    <img src={item.icon} className='img-icon' />
                                                }
                                            </label>
                                            <span className='ps-2'>{item.name}</span>
                                            {item[selectedId] == set[setString]?.activeID && (
                                                <>
                                                    <img src='/images/BackButton.svg' onClick={() => { setter((prevState) => ({ ...prevState, [setString]: { ...prevState[setString], activeID: null } })); resetCategories(); setShowDetailsDiv('d-none'); }} className='img-fluid cursor-pointer ps-2' style={{ height: "15px" }} />
                                                    {labelname != 'Issues' && (
                                                        <HoverPopover item={item} icon="/images/whiteinfo.svg" />
                                                    )}
                                                </>
                                            )}
                                        </button>
                                    </div>
                                </div>
                                :
                                <div className='py-2 align-items-center mx-2' key={index}>
                                    <button className={`helpDesk-button`} key={index}
                                        onClick={() => { onClick(item); setter((prevState) => ({ ...prevState, [setString]: { ...prevState[setString], activeID: item[selectedId] } })); }} title={item.name}>
                                        <label>
                                            {item.icon &&
                                                <img src={item.icon} className='img-icon' />
                                            }
                                        </label>
                                        <span className='ps-2'>{item.name}</span>
                                        {labelname != 'Issues' && (
                                            <HoverPopover item={item} icon="/images/greyinfo.svg" />
                                        )}
                                    </button>
                                </div>
                        ))
                    }</div>
                    :
                    <div className='col-12'>No record found</div>
                }
            </div>
        </div>
    )
};
export default function HelpdeskForm() {
    const { manager_user, staff_member, specific_user_no } = useConfig();
    const pathname = window.location.pathname;
    const pathArray = pathname.split('/');
    const schoolnumber = pathArray[2] || null;
    const [SchoolData, setSchoolData] = useState({
        schoolid: '',
        schoolname: '',
        logo: '',
        loginflag: '',
        microsoftgoogleflag: ''
    });
    const emptyObj = {
        "data": [],
        "visible": false,
        "activeID": null
    };
    const [MainData, setMainData] = useState({
        MainCategoriesData: emptyObj
    });
    const [error, setError] = useState('');
    const [Alldata, setAlldata] = useState({
        Name: '',
        Email: '',
        Flag: 2,
        Roomno: '',
        StudentNumber: '',
        Document: '',
        Filename: '',
        Description: '',
        loginToken: '',
        Title: '',
        Buildingname: '',
        Buildingid: '',
        RoomName: ''
    })
    const [isLoader, setLoader] = useState(true)
    const [Alerts, setAlerts] = useState('')
    const [ShowData, setShowData] = useState({ Description: null, IsResolved: false })
    const [ResolvedButtonVal, setResolvedButtonVal] = useState("")
    const [Video, setVideo] = useState('');
    const [EmailValidation, setEmailValidation] = useState("");
    const [BuildingValidation, setBuildingValidation] = useState("");
    const [ShowDetailsDiv, setShowDetailsDiv] = useState('d-none');
    const [loading, setLoading] = useState(false);
    const [LoginFlag, setLoginFlag] = useState(2);
    const [microsoftgoogleflag, setmicrosoftgoogleflag] = useState(2);
    const [isCheckedForOther, setIsCheckedForOther] = useState(false);
    const [RoomData, setRoomData] = useState([]);
    const [Buildings, setBuildings] = useState([]);
    const StateData = useSelector((state) => state.authData);
    const rawCookie = StateData?.helpTicketDetails;
    const recaptcharef = useRef();
    const activeFetchCount = useRef(0);
    var captchasitekey = process.env.REACT_APP_Captcha_Sitekey;
    useLayoutEffect(() => {
        ApiGetCallAuthKey(`/schools/by-number?schoolNumber=${schoolnumber}`).then((result) => {
            try {
                if (result == undefined || result == "") {
                    alert("Something went wrong");
                } else {
                    const { msg, logo, sso_type } = JSON.parse(result);
                    setSchoolData({
                        schoolid: msg.id,
                        schoolname: msg.name,
                        logo: logo || null
                    });
                    if (msg.help_desk == null) {
                        setLoginFlag(0);
                    } else {
                        setLoginFlag(msg.help_desk);
                    }
                    setmicrosoftgoogleflag(sso_type);
                    fetchDataForLink("MainCategoriesData", null, 3, msg.id);
                    getAllBuildings(setBuildings, msg.id);
                }
            } catch (e) {
                log.error(e)
            }
        });

    }, []);
    useEffect(() => {
        if (LoginFlag == 0) {
            GetCookiesData();
        }
    }, [LoginFlag]);
    useEffect(() => {
        if (!ShowData?.Description && ShowData?.IsResolved) {
            setShowDetailsDiv('');
        } else if (ShowData?.IsResolved && ResolvedButtonVal == "No") {
            setShowDetailsDiv('');
        } else if (ResolvedButtonVal == 'Yes') {
            setShowDetailsDiv('d-none');
            setAlerts(<AlertsComp show={true} variant="success" msg={"Details Sent Successfully."} />);
            setTimeout(function () {
                setAlerts(<AlertsComp show={false} />)
                window.location.href = `/submithelpdesk`;
            }, 2500);
        }
    }, [MainData, ShowData, ResolvedButtonVal, isLoader, ShowDetailsDiv]);
    async function fetchDataForLink(set, item, apiflag, schoolId = null) {
        let flag = false;
        let autoSelected = false;
        try {
            activeFetchCount.current += 1;
            setLoader(true);
            const SId = schoolId == null ? SchoolData.schoolid || null : schoolId || null
            await ApiGetCallAuthKey(`/helpdesk/data-by-id?schoolId=${SId}&uuid=${item}&flag=${apiflag}`).then((result) => {
                if (!result) {
                    alert("Something went wrong");
                } else {
                    const responseRs = JSON.parse(result);
                    if (responseRs.length != 0) {
                        responseRs.sort((a, b) => {
                            if (a.name < b.name) return -1;
                            if (a.name > b.name) return 1;
                            return 0;
                        });
                        if (responseRs.length === 1) {
                            const singleItem = responseRs[0];
                            setMainData((prevState) => ({
                                ...prevState,
                                [set]: { ...prevState[set], data: responseRs, visible: true, activeID: singleItem.id }
                            }));

                            if (set === "MainCategoriesData") {
                                fetchDataForLink("HelpDeskCategoryData", singleItem.id, 4, SId);
                            } else if (set === "HelpDeskCategoryData") {
                                fetchDataForLink("SubCategoryData", singleItem.id, 2, SId);
                            } else if (set === "SubCategoryData") {
                                fetchDataForLink("IssueData", singleItem.id, 2, SId);
                            } else if (set === "IssueData") {
                                setShowData({ Description: singleItem?.description, IsResolved: true });
                                setResolvedButtonVal("");
                                autoSelected = true;
                            }
                        } else {
                            setMainData((prevState) => ({
                                ...prevState,
                                [set]: { ...prevState[set], data: responseRs, visible: true, activeID: null }
                            }));
                        }
                        flag = false
                    } else {
                        if (item != null) {
                            flag = true
                        }
                    }
                }
            });
        } catch (e) {
            log.error(e)
        } finally {
            activeFetchCount.current -= 1;
            if (activeFetchCount.current === 0) {
                setLoader(false);
            }
            if (!autoSelected) {
                setShowData({ Description: null, IsResolved: flag })
            }
        }
    }
    const updateCategories = (clickedCategory) => {
        setMainData((prevData) => {
            const updatedData = { ...prevData };
            for (const key in updatedData) {
                if (clickedCategory == "MainCategoriesData" && key !== clickedCategory) {
                    updatedData[key] = { ...emptyObj };
                }
                else if (clickedCategory == "HelpDeskCategoryData" && key !== clickedCategory && key !== "MainCategoriesData") {
                    updatedData[key] = { ...emptyObj };
                }
                else if (clickedCategory == "SubCategoryData" && key !== clickedCategory && key !== "MainCategoriesData" && key !== "HelpDeskCategoryData") {
                    updatedData[key] = { ...emptyObj };
                }
            }
            return updatedData;
        });
        setShowData({ Description: null, IsResolved: false })
        setResolvedButtonVal("")
    };
    async function handleImageFileUpload(e) {
        const file = e.target.files[0];
        if (!file) return;
        const { isFileValid, validationMsg } = ValidateFile(file, { allowedType: "image", maxSizeMB: 2 })
        if (!isFileValid) {
            setError(validationMsg);
            setAlldata({ ...Alldata, Filename: "" });
            e.target.value = '';
            return;
        }

        const compressedFile = await compressImage(file);
        const reader = new FileReader();
        reader.onload = function (event) {
            setAlldata({ ...Alldata, Document: compressedFile, Filename: compressedFile.name });
            setError('');
        };
        reader.readAsDataURL(compressedFile);
        e.target.value = "";
    }

    async function SubmitHelpdesk() {
        var isFormValid = CheckValidation({ formID: 'HelpDeskForm' });

        // EMAIL VALIDATION
        if (!Alldata.Email || Alldata.Email.trim() === "") {
            setEmailValidation("*required");
            isFormValid = false;
        } else if (!isValidEmail(Alldata.Email)) {
            setEmailValidation("Invalid Email");
            isFormValid = false;
        } else {
            setEmailValidation("");
        }

        if (Alldata.Buildingid === '') {
            setBuildingValidation("*required");
            isFormValid = false;
        } else {
            setBuildingValidation("");
        }
        if (!isFormValid) return;
        setLoading(true);
        var categoryid = "";
        var subcategoryid = "";
        var issueid = "";
        if (MainData?.HelpDeskCategoryData) {
            categoryid = MainData?.HelpDeskCategoryData?.activeID;
        }
        if (MainData?.SubCategoryData) {
            subcategoryid = MainData?.SubCategoryData?.activeID;
        }
        if (MainData?.IssueData) {
            issueid = MainData?.IssueData?.activeID;
        }

        const token = await recaptcharef.current.executeAsync();
        // appendJwtAuthorization(myHeaders);
        const formdata = new FormData();
        formdata.append('schoolId', SchoolData.schoolid);
        formdata.append('typeId', MainData?.MainCategoriesData?.activeID);
        formdata.append('categoryId', categoryid);
        formdata.append('subCategoryId', subcategoryid);
        formdata.append('issueId', issueid);
        formdata.append('requesterType', Alldata.Flag);
        formdata.append('name', Alldata.Name);
        formdata.append('email', Alldata.Email);
        formdata.append('roomNumberId', Alldata.Roomno == "other" ? 0 : Alldata.Roomno);
        formdata.append('roomName', Alldata.RoomName);
        formdata.append('studentNumber', Alldata.StudentNumber);
        if (Alldata.Document) {
            formdata.append('document', Alldata.Document);
        }
        if (Video) {
            formdata.append('video', Video);
        }
        formdata.append('description', Alldata.Description);
        formdata.append('title', Alldata.Title);
        formdata.append('captcha', token);
        formdata.append('buildingId', Alldata.Buildingid);
        formdata.append('buildingName', Alldata.Buildingname);

        ApiCmnHeadersPostCall(`/helpdesk/save-requests`, formdata, false, true)
            .then(result => {
                const responseRs = JSON.parse(result);
                if (responseRs.response == "success") {
                    setAlerts(<AlertsComp show={true} variant="success" msg={"Help Desk sent successfully"} />);
                    setTimeout(function () {
                        setAlerts(<AlertsComp show={false} />)
                        window.location.href = `/submithelpdesk/${responseRs.hdrequestId}/${responseRs.schoolnumber}/${responseRs.hdrequestnum}/${responseRs.ticketGuId}`;
                    }, 2500);
                } else {
                    recaptcharef.current.reset();
                    setAlerts(<AlertsComp show={true} variant="danger" msg={responseRs.msg} />);
                }
                setLoading(false);
            })
            .catch(error => log.error('error', error));
    }
    function GetCookiesData() {
        if (rawCookie != undefined) {
            const decodedString = decodeURIComponent(rawCookie);
            const userDetailsForhelpdesk = JSON.parse(decodedString);
            setAlldata({ ...Alldata, Name: userDetailsForhelpdesk.name, Email: userDetailsForhelpdesk.email, loginToken: userDetailsForhelpdesk.accessToken })
        }
    }
    function getRooms(buildingid) {
        ApiGetCallAuthKey(`/buildings?uuid=${buildingid}`).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                const responseRs = JSON.parse(result);
                setRoomData(responseRs.msg?.room)
            }
        });
    }
    const handleReset = () => {
        setAlldata(prev => ({
            ...prev,
            Name: (prev.loginToken || rawCookie) ? prev.Name : '',
            Email: (prev.loginToken || rawCookie) ? prev.Email : '',
            Flag: 2,
            Roomno: '',
            StudentNumber: '',
            Document: '',
            Filename: '',
            Description: '',
            Title: '',
            Buildingname: '',
            Buildingid: '',
            RoomName: ''
        }));
        setVideo('');
        setEmailValidation("");
        setBuildingValidation("");
        setIsCheckedForOther(false);
        setRoomData([]);
        setError('');
        if (recaptcharef.current) {
            recaptcharef.current.reset();
        }
        setMainData((prev) => ({
            ...prev,
            HelpDeskCategoryData: emptyObj,
            SubCategoryData: emptyObj,
            IssueData: emptyObj
        }));
        setShowData({ Description: null, IsResolved: false });
        setResolvedButtonVal("");
        setShowDetailsDiv('d-none');
        const fileInput = document.getElementById('UploadFileId');
        if (fileInput) fileInput.value = '';
        fetchDataForLink("MainCategoriesData", null, 3, SchoolData.schoolid);
    };
    return (
        <>
            {Alerts}
            {loading ? <ShowLoder /> : <HideLoder />}
            <div className="row">
                {LoginFlag == 0 ?
                    <div className="helpdesk-container">
                        <div style={{ position: "fixed", top: 0, left: 0, width: "100%", height: "100%" }}>
                            <label style={{ objectFit: "cover", width: "100%" }}>
                                <CustomSVG src='/images/helpdeskbg.svg' stopColor="var(--primary-color)" width={"100%"} height={"100%"} />
                            </label>
                        </div>
                        <div className='position-relative' style={{ paddingLeft: "15%", paddingRight: "10%" }}>
                            <div className='col-12 pt-4 px-4'>
                                <div className='col-12 font-14' style={{ color: "#6A6A6A" }}>
                                    Helping hand from
                                    <img src='/images/HelloHand.svg' className='ps-2 img-fluid byebye-animation' />
                                </div>
                                <div className='col-12 mt-2 '>
                                    <h4 className='fw-600 mb-0'>{SchoolData.schoolname}</h4>
                                </div>
                                <label style={{ color: "#6A6A6A", fontWeight: "500" }} className='font-13'>Choose one of the options below that best addresses your inquiry.</label>
                            </div>
                            {MainData?.MainCategoriesData?.data.length > 0 ?
                                <>
                                    <div className="p-4 row">
                                        <div className="col-12">
                                            {MainData?.MainCategoriesData?.visible && (
                                                <Category resetCategories={() => updateCategories("MainCategoriesData")} data={MainData?.MainCategoriesData?.data}
                                                    onClick={(item) => { MainData?.MainCategoriesData?.activeID != item?.id && fetchDataForLink("HelpDeskCategoryData", item?.id, 4) }}
                                                    labelname="Hello, what type of help do you need today?" set={MainData} setString="MainCategoriesData" setter={setMainData} selectedId={"id"} setShowDetailsDiv={setShowDetailsDiv} />
                                            )}
                                            {MainData?.HelpDeskCategoryData?.visible && (
                                                <Category resetCategories={() => updateCategories("HelpDeskCategoryData")} data={MainData?.HelpDeskCategoryData?.data}
                                                    onClick={(item) => { MainData?.HelpDeskCategoryData?.activeID != item?.id && fetchDataForLink("SubCategoryData", item?.id, 2) }}
                                                    labelname="Please choose Category from below options:" set={MainData} setString="HelpDeskCategoryData" setter={setMainData} selectedId={"id"} setShowDetailsDiv={setShowDetailsDiv} />
                                            )}
                                            {MainData?.SubCategoryData?.visible && (
                                                <Category resetCategories={() => updateCategories("SubCategoryData")} data={MainData?.SubCategoryData.data}
                                                    onClick={(item) => { MainData?.SubCategoryData?.activeID != item?.id && fetchDataForLink("IssueData", item?.id, 2) }}
                                                    labelname="Please choose Subcategory from below options:" set={MainData} setString="SubCategoryData" setter={setMainData} selectedId={"id"} setShowDetailsDiv={setShowDetailsDiv} />
                                            )}
                                            {MainData?.IssueData?.visible && (
                                                <Category resetCategories={() => updateCategories("IssueData")} data={MainData?.IssueData?.data}
                                                    onClick={(item) => { setShowData({ Description: item?.description, IsResolved: true }); setResolvedButtonVal("") }}
                                                    labelname="Please choose the type of issue from below options:" set={MainData} setString="IssueData" setter={setMainData} selectedId={"id"} setShowDetailsDiv={setShowDetailsDiv} />
                                            )}
                                            {ShowData?.Description && <>
                                                <div className="row py-3">
                                                    <div className='col-md-5 questionchatbox ql-editor' style={{ background: "white" }}>
                                                        {CustomParseSafeHtml(ShowData?.Description) || ""}
                                                    </div>
                                                </div>
                                            </>}
                                            {(ShowData?.Description && ShowData?.IsResolved) && (
                                                <div className='row py-3'>
                                                    <div className="col-12">
                                                        <div className='col-md-5 helpDesk-button active p-3'>
                                                            Did this solution resolve the issue?
                                                        </div>
                                                    </div>
                                                    <div className='col-12 my-2'>
                                                        <div className='row'>
                                                            <div className='col-6' />
                                                            <div className='col-6 justify-content-end d-flex'>
                                                                <button className={`helpDesk-button ${ResolvedButtonVal == 'Yes' ? 'active' : ""} my-3 me-2`} value="Yes" onClick={(e) => setResolvedButtonVal(e.target.value)} title='Yes, Close Request'>Yes, Close Request</button>
                                                                <button className={`helpDesk-button ${ResolvedButtonVal == 'No' ? 'active' : ""} my-3`} value="No" onClick={(e) => setResolvedButtonVal(e.target.value)} title='No, Open Ticket'>No, Open Ticket</button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                            {ResolvedButtonVal && <>
                                                <div className="row my-3">
                                                    <div className='col-md-5 helpDesk-button active p-3'>
                                                        {ResolvedButtonVal == "Yes" ? "We are happy to help you! Have a great day! 😄" : "Thank you for your time. Your ticket has been submitted. We will reach out to you shortly with updates!"}
                                                    </div>
                                                </div>
                                            </>}
                                            {isLoader && <div className="row">
                                                <div className="col-1"><Dotsloder /></div>
                                            </div>}
                                        </div>
                                    </div>
                                    <div className={`py-2 ${ShowDetailsDiv} GridBox `}>
                                        <div className='col-12 text-center'>
                                            <u> <b className=''>Create your ticket below:</b></u>
                                        </div>
                                        <div className="col-12 font-15 px-5 text-center row pt-3">
                                            <div className='d-flex ps-4 align-items-center font-13'>
                                                <b className='pe-5 font-12' style={{ color: "#495057" }}>Role:</b>
                                                <div className="form-check">
                                                    <input className="form-check-input cursor-pointer" type="radio" name='role' defaultChecked={Alldata.Flag == 2} onChange={(e) => { setAlldata({ ...Alldata, Flag: 2 }) }} />
                                                    <label className="form-check-label">{staff_member} </label>
                                                </div>
                                                <div className="form-check ms-3">
                                                    <input className="form-check-input cursor-pointer" type="radio" name='role' defaultChecked={Alldata.Flag == 1} onChange={(e) => { setAlldata({ ...Alldata, Flag: 1 }) }} />
                                                    <label className="form-check-label"> {manager_user} </label>
                                                </div>
                                            </div>
                                        </div>
                                        <div className={`px-5 parent `} id='HelpDeskForm' >
                                            <div className='row'>
                                                <div className="align-items-center row py-2 px-4">
                                                    <b className="font-12" style={{ color: "#495057" }}>
                                                        Is there a specific building for this issue?</b>
                                                </div>
                                                <div className='col-12 pb-2 px-4'>
                                                    <div className="row">
                                                        {Buildings.map((item, i) => {
                                                            return <div className="col-md-3 py-1 font-13 d-flex align-items-start text-break">
                                                                <input type="radio" className="form-check-input me-2"
                                                                    onChange={(e) => {
                                                                        setAlldata({
                                                                            ...Alldata, Buildingid: item.id, Buildingname: '',
                                                                            Roomno: "", RoomName: ""
                                                                        });
                                                                        setIsCheckedForOther(false); getRooms(item.id)
                                                                    }}
                                                                    name={"building"} bid={item.id}
                                                                />
                                                                {item.name}
                                                            </div>
                                                        })}
                                                        <div className="col-md-3 py-1 font-13">
                                                            <input type="radio" className="form-check-input me-2" name={"building"}
                                                                checked={isCheckedForOther} onChange={(e) => {
                                                                    setAlldata({
                                                                        ...Alldata, Buildingid: 0, Buildingname: '',
                                                                        Roomno: "", RoomName: ""
                                                                    }); setRoomData([]); setIsCheckedForOther(e.target.checked)
                                                                }}
                                                            />
                                                            Other
                                                        </div>
                                                        {isCheckedForOther == true && (
                                                            <div className='col-4'>
                                                                <input type="text" placeholder="Enter Building*" required autoComplete='off' name='building' className="form-control" value={Alldata.Buildingname} onChange={(e) => setAlldata({ ...Alldata, Buildingname: e.target.value })} />
                                                                <span className="form-text invalid-feedback">
                                                                    *required
                                                                </span>
                                                            </div>
                                                        )}
                                                        <span style={{ fontSize: '.875em', color: "var(--error_text_color)" }}>{BuildingValidation}</span>
                                                    </div>
                                                </div>
                                                <div className='col-md-4 py-3'>
                                                    <div className='col-12'>
                                                        <input type="text" placeholder="Subject*" autoComplete='off' name='Subject' className="form-control" required value={Alldata.Title} onChange={(e) => setAlldata({ ...Alldata, Title: e.target.value })} />
                                                        <span className="form-text invalid-feedback">
                                                            *required
                                                        </span>
                                                    </div>
                                                </div>
                                                <div className='col-md-4 py-3'>
                                                    <div className='col-12'>
                                                        <input type="text" placeholder="Name*" autoComplete='off' name='name' className="form-control" required value={Alldata.Name} onChange={(e) => setAlldata({ ...Alldata, Name: e.target.value })} />
                                                        <span className="form-text invalid-feedback">
                                                            *required
                                                        </span>
                                                    </div>
                                                </div>
                                                <div className='col-md-4 py-3'>
                                                    <div className='col-12'>
                                                        <input type="email" placeholder="Email*" autoComplete='off' name='email' className="form-control" value={Alldata.Email} onChange={(e) => setAlldata({ ...Alldata, Email: e.target.value })} />
                                                        <span style={{ fontSize: '.875em', color: "var(--error_text_color)" }}>{EmailValidation}</span>
                                                    </div>
                                                </div>
                                                {Alldata.Flag != 1 && (
                                                    <div className='col-md-4 py-3'>
                                                        <div className='col-12'>
                                                            <select value={Alldata.Roomno} onChange={(e) => {
                                                                setAlldata({ ...Alldata, Roomno: e.target.value, RoomName: "" });
                                                            }}>
                                                                <option value="0">Select Room</option>
                                                                {RoomData?.length &&
                                                                    RoomData?.map((item, i) => {
                                                                        return <option key={i} value={item.id}>{item.name}</option>
                                                                    })
                                                                }
                                                                <option value="other">Other</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                )}
                                                {Alldata.Roomno == "other" && (
                                                    <div className='col-4 py-3'>
                                                        <input type="text" placeholder="Enter Room*" required autoComplete='off' name='building' className="form-control" value={Alldata.RoomName} onChange={(e) => setAlldata({ ...Alldata, RoomName: e.target.value })} />
                                                        <span className="form-text invalid-feedback">
                                                            *required
                                                        </span>
                                                    </div>
                                                )}
                                                <div className='col-md-4 py-3'>
                                                    <div className='col-12'>
                                                        {Alldata.Flag != 1 ?
                                                            <input type="text" placeholder={specific_user_no} autoComplete='off' name='studentno' className="form-control" value={Alldata.StudentNumber} onChange={(e) => setAlldata({ ...Alldata, StudentNumber: e.target.value.toUpperCase() })} />
                                                            :
                                                            <>
                                                                <input type="text" placeholder={specific_user_no + "*"} required autoComplete='off' name='studentno' className="form-control" value={Alldata.StudentNumber} onChange={(e) => setAlldata({ ...Alldata, StudentNumber: e.target.value.toUpperCase() })} />
                                                                <span className="form-text invalid-feedback">
                                                                    *required
                                                                </span>
                                                            </>
                                                        }
                                                    </div>
                                                </div>
                                                <div className='col-md-4 py-3'>
                                                    <input type="file" label="img" id="UploadFileId" name="myFile" accept=".jpg,.png,.jpeg" onChange={(e) => handleImageFileUpload(e)} />
                                                    <label className="supportTicketbtn col-md-12 cursor-pointer" htmlFor="UploadFileId" style={{ color: "#909091" }}>
                                                        Choose File (Attach Image)
                                                    </label>
                                                    {Alldata.Filename && <label className="ps-2 mt-1" style={{ fontWeight: "600", color: 'var(--primary-color)', wordBreak: 'break-all' }}>{Alldata.Filename} </label>}
                                                    {error?.trim() != "" && <div className="ps-2 mt-1 redText">{error}</div>}
                                                </div>
                                                <VideoUpload selectedFile={(e) => setVideo(e)} />
                                                <div className="col-md-8 pb-3">
                                                    <textarea placeholder="Ticket Description" type="textarea" rows={3} autoComplete="off" name="RepairedNm" className="form-control" value={Alldata.Description} onChange={(e) => setAlldata({ ...Alldata, Description: e.target.value })} />
                                                </div>
                                                <div className="d-flex justify-content-center">
                                                    <ReCAPTCHA ref={recaptcharef} sitekey={captchasitekey} size='invisible' />
                                                </div>

                                                <div className="col-md-12 text-center mt-2 pt-3 justify-content-center align-items-center">
                                                    <button className="SaveBtn mt-2" onClick={SubmitHelpdesk}>Submit Ticket</button>
                                                    <label className="ms-2 cursor-pointer" onClick={handleReset}> <u>Reset</u></label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </>
                                :
                                <div className='col-12 text-center m-5'>Loading Help Desk information..</div>
                            }
                        </div>
                    </div>
                    :
                    LoginFlag == 1 ?
                        microsoftgoogleflag == 1 ?
                            <>
                                <LazyLoadImage src="/images/LoginBg.png" alt="" className="MainDiv-bg-image" />
                                <div className="position-relative MainDiv">
                                    <GoogleLoginForSupportTicket flag="helpdesk" setLoginFlag={setLoginFlag} setallData={setAlldata} allData={Alldata} />
                                </div>
                            </>
                            :
                            <>
                                <LazyLoadImage src="/images/LoginBg.png" alt="" className="MainDiv-bg-image" />
                                <div className="position-relative MainDiv">
                                    <MicrosoftLoginForSupportTicket flag="helpdesk" setLoginFlag={setLoginFlag} />
                                </div>
                            </>
                        :
                        <></>
                }
            </div >

        </>
    )
}
